

import { call, put, takeLatest, takeEvery,select } from 'redux-saga/effects';
import { blogActions } from '../actions/blogActions';
import { type } from '@testing-library/user-event/dist/type';
import { json } from 'react-router-dom';
import Axios from '../../utils/axiosInstance';

const API_URL = process.env.REACT_APP_API_BASE_URL;
const selectAuthToken = (state) => state.auth.token;

function* getAuthHeader(){
  const token = yield select(selectAuthToken)
   const authHead = {
    crossDomain: true,
    headers: {
      'Authorization': `Bearer ${token.access}`,
      'content-type': 'multipart/form-data; boundary=----WebKitFormBoundarydZ6jmQ1T03hYxfyV'

    },
    withCredentials: true, // Enable credentials for this specific request
    
  }
  return authHead;
}
function* fetchBlogsSaga(action) {
  try {
    const page = action.payload.currentPage;
    const userid = action.payload.user_id;
    const URL = userid? `${API_URL}blog/blogs/?page=${page}&page_size=10&user_id=${userid}` : `${API_URL}blog/blogs/?page=${page}`
    const response = yield call(Axios.get, URL);
    const { results: blogs, count: totalBlogs } = response.data;
    const blogsPerPage = 9;
    const hasMore = totalBlogs > page * blogsPerPage;

    yield put({
      type: blogActions.FETCH_BLOGS_SUCCESS,
      payload: { blogs, hasMore, currentPage: page },
    });
  } catch (error) {
    yield put({
      type: blogActions.FETCH_BLOGS_FAILURE,
      payload: error.message,
    });
  }
}

function* uploadImageSaga(action) {
  try {
    
      const response = yield call(Axios.post, `${API_URL}blog/upload-blog-images/`, action.payload.formData,yield call(getAuthHeader));
     
      if (action.payload.callback) {
        action.payload.callback(response.data); // Assuming the server response has a 'url' field
      }
      
      yield put({
        type: blogActions.UPLOAD_IMAGE_SUCCESS,
        payload: response.data,
      });
      
  } catch (error) {
    yield put({
      type: blogActions.UPLOAD_IMAGE_FAILURE,
      payload: error.message,
    });
  }
}

function* removeImageSaga(action) {
  try {
    const { payload: image_urls } = action;
    
    let dt = {
      "image":image_urls
    }
    yield call(Axios.post, `${API_URL}blog/delete-images/`,dt,yield call(getAuthHeader));

    yield put({
      type: blogActions.REMOVE_IMAGE_SUCCESS,
      payload: action.payload,
    });
  } catch (error) {
    yield put({
      type: blogActions.REMOVE_IMAGE_FAILURE,
      payload: error.message,
    });
  }
}

function* saveBlogSaga(action) {
  try {
     yield call(Axios.post,  `${API_URL}blog/create/`, action.payload.formData, yield call(getAuthHeader) );
    yield put({
      type: blogActions.SAVE_BLOG_SUCCESS,
    });
    if (action.payload.callback) {
      action.payload.callback(); // This will show toast and navigate
    }
  } catch (error) {
    yield put({
      type: blogActions.SAVE_BLOG_FAILURE,
      payload: error.message,
    });
  }
}

function* handleDeleteBlog(action) {
  try {
    yield call(Axios.delete, `${API_URL}blog/delete/${action.payload}/`, yield call(getAuthHeader));
    yield put({
      type: blogActions.DELETE_BLOG_SUCCESS,
      payload: action.payload,
    });
  } catch (error) {
    yield put({
      type: blogActions.DELETE_BLOG_FAILURE,
      payload: error.message,
    });
  }
}

function* fetchBlogSagaById(action) {
  try {
    const response = yield call(Axios.get, `${API_URL}blog/post/${action.payload.id}`);
    yield put({
      type: blogActions.FETCH_BLOG_SUCCESS_BYID,
      payload: response.data.data,  // Blog data from API response
    });

    // If a callback is provided, execute it with the fetched data
    if (action.callback) {
      action.callback(response.data.data);
    }
  } catch (error) {
    yield put({
      type: blogActions.FETCH_BLOG_FAILURE_BYID,
      payload: error.message,
    });
  }
}

export function* watchFetchBlogs() {
  yield takeEvery(blogActions.FETCH_BLOGS_REQUEST, fetchBlogsSaga);
  yield takeLatest(blogActions.UPLOAD_IMAGE_REQUEST, uploadImageSaga);
  yield takeLatest(blogActions.REMOVE_IMAGE_REQUEST, removeImageSaga);
  yield takeLatest(blogActions.SAVE_BLOG_REQUEST, saveBlogSaga);
  yield takeLatest(blogActions.FETCH_BLOG_REQUEST_BYID, fetchBlogSagaById);
  yield takeLatest(blogActions.DELETE_BLOG_REQUEST, handleDeleteBlog);
}

export default watchFetchBlogs;